export default "__VITE_ASSET__33a8d296__"